import React, { useState, useEffect, useRef, useMemo } from "react";
//assets
import arrowOff from "img/QuoteDropDownOff.svg";
import arrowOn from "img/QuoteDropDownOn.svg";
//components
import { Column, Row } from "components/Layout/Grid";
import Text from "components/Text";
//interfaces
import { OptionsDropdownProps } from "../QuoteStatusFilter/interface";
//styles
import "../QuoteStatusFilter/style.scss";

interface QuoteCategoryFilterProps {
  selectedQuoteCategory: string[];
  dashboardQuoteFilter?: any;
  setQuoteCategory: any;
  setCurrentPage: (currentPage: number) => void;
  notReloadStatus?: boolean;
}

const QuoteCategoryFilter: React.FC<QuoteCategoryFilterProps> = (props) => {
  const {
    selectedQuoteCategory,
    dashboardQuoteFilter,
    setQuoteCategory,
    setCurrentPage,
    notReloadStatus
  } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [style, setStyle] = useState<string>("none");
  const [arrow, setArrow] = useState<string>(arrowOff);
  const [searchQuoteCategoryOptions, setSearchQuoteCategoryOptions] = useState<OptionsDropdownProps[]>([]);

  const dropdownMenu: any = useRef(null);

  useMemo(() => {
    if (dashboardQuoteFilter) {
      setSearchQuoteCategoryOptions(dashboardQuoteFilter.categoryMafraOptions || []);
    }
  }, [dashboardQuoteFilter]);

  const handleOpenCloseDropDownMenu = () => {
    if (open === false) {
      setOpen(true);
      setStyle("block");
      setArrow(arrowOn);
    } else {
      setOpen(false);
      setStyle("none");
      setArrow(arrowOff);
    }
  };

  const closeOpenMenus = (e: any) => {
    if (dropdownMenu?.current && open && !dropdownMenu?.current.contains(e.target)) {
      handleOpenCloseDropDownMenu();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeOpenMenus);
  }, [open]);

  const handleQuoteCategory = (selectedDashboardQuoteFilterProps: any) => {
    let newCatSelection: string[] = selectedQuoteCategory;

    if (selectedDashboardQuoteFilterProps.target.checked) {
      newCatSelection.push(selectedDashboardQuoteFilterProps.target.value);
    } else {
      newCatSelection = newCatSelection.filter(
        (cat: string) => cat !== selectedDashboardQuoteFilterProps.target.value
      );
    }
    setQuoteCategory([...newCatSelection]);
    !notReloadStatus && setCurrentPage(0);
  };

  const selectedCount = selectedQuoteCategory.length;

  return (
    <Row className="w-md-100">
      <Column className="w-md-100">
        <Row>
          <Text className="StatusFilterLabel" size={12}>
            Categoria
          </Text>
        </Row>
        <div ref={dropdownMenu}>
          <Row>
            <Column className="w-md-100">
              <div
                className="StatusFilterDropDown w-md-100"
                style={{ borderColor: open ? "#0E4C54" : "#BEBEBE" }}
                onClick={() => {
                  handleOpenCloseDropDownMenu();
                }}
              >
                <Text size={12}>Selecionados ({selectedCount})</Text>
                <img alt="arrow icon" src={arrow} />
              </div>
            </Column>
          </Row>
          <Row>
            <div className="StatusFilterOptionsArea" style={{ display: style }}>
              <div>
                <li className="StatusFilterStatusPlace">Categoria da cotação</li>
                <ul>
                  {searchQuoteCategoryOptions.map((value) => {
                    return (
                      <li className="StatusFilterStatusRow" key={value.value}>
                        <label className="StatusFilterStatusItem">
                          <input
                            type="checkbox"
                            onChange={(event) => handleQuoteCategory(event)}
                            value={value.value}
                            name={`opt-${value.status}`}
                            className="StatusFilterCheckbox"
                            checked={!!selectedQuoteCategory.find(element => element === value.value)}
                          />
                          <span className="StatusFilterCheckbox"></span>
                          <span className="StatusFilterStatusLabel">
                            {value.status}
                          </span>
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </Row>
        </div>
      </Column>
    </Row>
  );
};

export default QuoteCategoryFilter;

